import { render, staticRenderFns } from "./c_select_item.vue?vue&type=template&id=470cda0e&scoped=true"
import script from "./c_select_item.vue?vue&type=script&lang=js"
export * from "./c_select_item.vue?vue&type=script&lang=js"
import style0 from "./c_select_item.vue?vue&type=style&index=0&id=470cda0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470cda0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470cda0e')) {
      api.createRecord('470cda0e', component.options)
    } else {
      api.reload('470cda0e', component.options)
    }
    module.hot.accept("./c_select_item.vue?vue&type=template&id=470cda0e&scoped=true", function () {
      api.rerender('470cda0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_select_item.vue"
export default component.exports